import * as React from "react";
import Booth from "../../_data/models/Booth";
import Shop from "../../_data/models/Shop";
import BoothListItemContainer from "../../booth/containers/BoothListItemContainer";
import Meta from "../../_data/models/Meta";
import {getCurrentUser} from "../../_helpers/utils";
import {Link} from "react-router-dom";
import {ShopsRoutes} from "../../routes";
import ReduxInfiniteScroll from 'redux-infinite-scroll';

interface Props {
    items: Booth[];
    meta: Meta;
    loading: boolean;
    loadMore: (meta: Meta) => void;
    shop: Shop;
}

const ShopBoothsComponent = (props: Props) => {

    const {items, shop, loadMore, loading, meta} = props;
    const withOwnerPermission: boolean = getCurrentUser() ? shop.isOwnedBy(getCurrentUser().id) : false;

    return (
        <ReduxInfiniteScroll
            holderType="ul"
            className="list-block flex-container"
            loadMore={() => loadMore(meta)}
            elementIsScrollable={false}
            loadingMore={loading}
            showLoader={false}
            threshold={200}>
            {
                items.map((each: Booth) => {
                    return <BoothListItemContainer {...props} key={"booth_"+each.id} booth={each}/>;
                })
            }

            { withOwnerPermission &&
            <li className="bb-0">
                <div className="m0-auto add-media mb-1">
                    <div className="text-center p1 pb-1">
                        <Link to={ShopsRoutes.addBooth(shop.id)} className="button hollow pull-right">
                            <h5 className="mb-0 text-upper"><i className="fa fa-plus mr-half" aria-hidden="true"></i> Click here to add booth</h5>
                        </Link>
                    </div>
                </div>
            </li>
            }
        </ReduxInfiniteScroll>

    );
};

export default ShopBoothsComponent;


// WEBPACK FOOTER //
// ./app/client/shop/components/ShopBoothsComponent.tsx